// extracted by mini-css-extract-plugin
export var deleteIcon = "_ty-5";
export var deleteOption = "_ty-3";
export var divider = "_ty-2";
export var downloadIcon = "_ty-4";
export var drawer = "_ty-0";
export var drawerFooter = "_ty-6";
export var drawerOpen = "_ty-1";
export var highlighted = "_ty-7";
export var lighterHighlight = "_ty-8";